import Vue from 'vue'
import Vuex from 'vuex'
import processingQueue from './processing-queue'
import user from './user'
import setupSearchModule from './search'
import enrollmentStaging from './enrollment-staging'
import providerStaging from './provider-staging'
import flkrsStaging from './flkrs-staging'
import programYear from './program-year'
import timeline from './timeline'
import arrpProviders from './arrp-providers'
import arrpEnrollments from './arrp-enrollments'
import manualMatch from './manual-match'
import apiConnection from '$app/plugins/api-connection'
import getConfigs from '$app/configs'

Vue.use(Vuex)

// STATE
const state = {
  counties: [],
  coalitions: [],
  programTypes: [],
  providerTypes: [],
  races: [],
  configs: {},
  loading: false
}

// MUTATIONS
const mutations = {
  setLoading(state, val) {
    state.loading = val;
  },
  setProps(state, obj) {
    for (const key in obj) {
      if (key in state) {
        state[key] = obj[key]
      }
    }
  }
}

// ACTIONS
const actions = ({
})

// GETTERS
const getters = {
  counties: (state) => state.counties,
  coalitions: (state) => state.coalitions,
  programTypes: (state) => state.programTypes,
  providerTypes: (state) => state.providerTypes,
  races: (state) => state.races
}

const store = new Vuex.Store({
  modules: {
    processingQueue,
    user,
    enrollmentStaging,
    flkrsStaging,
    providerStaging,
    programYear,
    timeline,
    arrpProviders,
    arrpEnrollments,
    manualMatch
  },
  state,
  getters,
  mutations,
  actions
})

setupSearchModule(store);

getConfigs().then(configs => {
  store.commit('setProps', { configs });
  const info = { rowsPerPage: configs.tablePageSize || 10 };
  store.commit('arrpProviders/updatePagingInfo', info);
  store.commit('arrpEnrollments/updatePagingInfo', info);
  store.commit('providerStaging/updatePagingInfo', info);
  store.commit('enrollmentStaging/updatePagingInfo', info);
  store.commit('flkrsStaging/updatePagingInfo', info);
  store.commit('manualMatch/updatePagingInfo', info);
})

apiConnection.get('api/GetAllCounties').then(response => {
  store.commit('setProps', { counties: response.data });
});

apiConnection.get('api/GetAllCoalitions').then(response => {
  const coalitions = response.data.map(p => ({
    ...p,
    elccoalitionFullName: p.elccoalitionName,
    elccoalitionName: p.elccoalitionName.replace(/\s*\(.*/, '')
  }));
  store.commit('setProps', { coalitions });
});

apiConnection.get('api/GetAllProviderTypes').then(response => {
  store.commit('setProps', { providerTypes: response.data });
});

apiConnection.get('api/GetAllProgramTypes').then(response => {
  store.commit('setProps', { programTypes: response.data });
});

apiConnection.get('api/GetAllRaces').then(response => {
  store.commit('setProps', { races: response.data });
});

export default store
